import React from 'react'
import s from './Footer.module.scss'

export default function Footer(props) {
  return (
    <div className={s.footer}>     
      <hr /> 
      <ul>
        <li>
          <a href="https://www.kia.com/us/en/terms-of-service" target="_blank" rel="noreferrer">Terms of Service</a>
        </li>
        <li>
          <a href="https://www.kia.com/us/en/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
        </li>
      </ul>
      <p>Copyright © 2022 Kia America, Inc.</p>
    </div>
  );
}
